import {formatFromMinutes, formatToMinutes} from './general-task-utils';
import {EffortType} from './effort-type';
import {BaseTaskRes} from './base-task.contract';

abstract class _taskEffortBase {
    estimatedDurationInMin?: number;
    actualDurationInMin?: number;
    name?: string;
    description?:string;
    index?: number;

    constructor(estimatedDurationInMin?: number, actualDurationInMin?: number, index?: number) {
        this.estimatedDurationInMin = estimatedDurationInMin;
        this.actualDurationInMin = actualDurationInMin;
        this.index = index;
    }

    /**
     * expect input like youtrack i.e. 1w 2d 4h
     */
    set estimatedDuration(value: string) {
        this.estimatedDurationInMin = formatToMinutes(value)
    }

    /**
     * returns output like youtrack i.e. 1w 2d 4h
     */
    get estimatedDuration(): string | undefined {
        if (this.estimatedDurationInMin === undefined) return undefined
        return formatFromMinutes(this.estimatedDurationInMin)
    }

    /**
     * expect input like youtrack i.e. 1w 2d 4h
     */
    set actualDuration(value: string) {
        this.actualDurationInMin = formatToMinutes(value)
    }

    /**
     * returns output like youtrack i.e. 1w 2d 4h
     */
    get actualDuration(): string | undefined {
        if (this.actualDurationInMin === undefined) return undefined
        return formatFromMinutes(this.actualDurationInMin)
    }
}

export class TaskEffortRes extends _taskEffortBase {
    id!: string;
    effort!: EffortType;
    taskId!: string;

    toUpdate() {
        return new TaskEffortUpdateReq({
            id: this.id,
            effortTypeId: this.effort.id,
            taskId: this.taskId,
            estimatedDurationInMin: this.estimatedDurationInMin,
            actualDurationInMin: this.actualDurationInMin,
            index: this.index,
        });
    }

    toCreate() {
        return new TaskEffortCreateReq({
            effortTypeId: this.effort.id,
            taskId: this.taskId,
            estimatedDurationInMin: this.estimatedDurationInMin,
            actualDurationInMin: this.actualDurationInMin,
            index: this.index,
        });
    }
}

export class TaskEffortCreateReq extends _taskEffortBase {
    effortTypeId!: string;
    taskId!: string;

    constructor(partial: Partial<TaskEffortCreateReq>) {
        super(partial.estimatedDurationInMin, partial.actualDurationInMin, partial.index);
        if ((partial.taskId !== undefined || partial.effortTypeId !== undefined)) {
            this.effortTypeId = partial.effortTypeId!
            this.taskId = partial.taskId!
        }
    }
}

export class TaskEffortUpdateReq extends TaskEffortCreateReq {
    id!: string;

    constructor(partial: Partial<TaskEffortUpdateReq>) {
        super(partial);
        if (partial.taskId === undefined) {
            throw new Error("no taskId is defined");
        }
        this.taskId = partial.taskId
    }
}